import React, { FC } from 'react';
import { Page } from 'components/molecules/page';
import { TemplateDetailHeader } from '../../commons';
import { ProjectTemplateGanttPage } from './gantt';

export const ProjectTemplateTimeline: FC = () => {
  return (
    <Page>
      <TemplateDetailHeader />
      <Page.Content>
        <ProjectTemplateGanttPage />
      </Page.Content>
    </Page>
  );
};
